<template>
  <div class="page">
    <div class="top-bg"></div>
    <div class="search-wrap">
      <van-popover
        v-model="campusObj.show"
        trigger="click"
        :actions="campusObj.list"
        @select="handleCampusSelect"
        placement="bottom-start"
      >
        <template #reference>
          <div class="campus" v-if="campusObj.campusShortName">
            <div class="text" v-text="campusObj.campusShortName"></div>
            <van-icon class="arrow" name="arrow-down" />
          </div>
        </template>
      </van-popover>
      <div
        class="search"
        :class="{ ml: !campusObj.campusShortName }"
        @click="handleARouterBookSearch"
      >
        <img
          class="search-icon"
          src="../assets/images/icon-search2.png"
          alt="搜索"
        />
        <div class="placeholder">请输入关键词搜索</div>
      </div>
    </div>
    <div class="hot-search-wrap" v-show="false">
      <div class="title">热搜</div>
      <div class="hot-wrap" ref="hotWrap">
        <div class="hot-list">
          <div
            class="hot-item"
            v-for="(item, index) in hotSearchList"
            :key="index"
            v-text="item.keyWords"
            @click="handleHotSearchClick(item)"
          ></div>
        </div>
      </div>
    </div>
    <div class="carousel-wrap">
      <van-swipe
        ref="mSwipe"
        class="m-swipe-wrap"
        :autoplay="3000"
        indicator-color="#3770d3"
      >
        <van-swipe-item
          class="m-swipe"
          v-for="(item, index) in rotationList"
          :key="index"
          @click="handleOpenUrl(item.jumpAddress)"
        >
          <img
            class="swiper-img"
            :src="item.bannerFileUrl"
            :data-url="item.jumpAddress"
            alt="轮播图"
          />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="person-num-wrap" v-if="campusObj.campusShortName">
      <div
        class="campus-name"
        @click="handleLibOpenTimeShow(campusObj)"
        v-if="campusObj.libraryOpenTime"
      >
        <img
          class="icon-time"
          src="../assets/images/icon-time.png"
          alt="开放时间"
        />
        <div>开放时间</div>
      </div>
      <div class="person-num-list">
        <div class="person-num-item">
          <div
            class="num"
            v-text="parseInt(campusObj.inNum) + parseInt(campusObj.canInNumb)"
          ></div>
          <div class="text">在馆人数限制</div>
        </div>
        <div class="person-num-item">
          <div class="num" v-text="campusObj.inNum"></div>
          <div class="text">实时在馆人数</div>
        </div>
        <div class="person-num-item">
          <div class="num" v-text="campusObj.canInNumb"></div>
          <div class="text">剩余可进馆数</div>
        </div>
      </div>
    </div>
    <div class="notice-wrap" v-if="noticeStr" @click="handleNoticeShow">
      <img
        class="notice-icon"
        src="../assets/images/icon-gonggao.png"
        alt="公告"
      />
      <van-notice-bar
        class="notice"
        :text="removeRickFormat(noticeStr)"
        background="#fff"
        color="#666"
      />
    </div>
    <div class="u-application-wrap" v-if="homeUAppList.length > 0">
      <van-grid icon-size="44px" square :border="false" :column-num="5">
        <van-grid-item
          v-for="(item, index) in homeUAppList"
          :key="index"
          @click="handleAppClick(item)"
          :icon="item.appIconFileUrl"
          :text="item.appName"
        />
      </van-grid>
    </div>
    <div
      class="application-wrap"
      v-if="homeUnAppList.length > 0"
      ref="appScroll"
    >
      <div class="application-list">
        <div
          class="application-item"
          v-for="(item, index) in homeUnAppList"
          :key="index"
          @click="handleAppClick(item)"
        >
          <img class="application-icon" :src="item.appIconFileUrl" alt="图标" />
          <div class="application-text" v-text="item.appName"></div>
        </div>
      </div>
    </div>
    <div class="progress-wrap" v-show="appProgressShow">
      <m-progress :percentage="appProgress" />
    </div>
    <div class="huodong-wrap" v-if="newActivityList.length > 0">
      <div class="m-title-wrap">
        <div class="left">
          <div class="title">最新活动</div>
        </div>
        <div class="right" @click="handleRouterActivity">
          <div class="more">更多</div>
          <van-icon class="arrow" name="arrow" />
        </div>
      </div>
      <div class="huodong-list-wrap" ref="huodongScroll">
        <div class="huodong-list">
          <div
            class="huodong-item"
            v-for="(item, index) in newActivityList"
            :key="index"
            @click="handleActivityDetail(item)"
          >
            <img
              class="banner"
              :src="
                item.activityPicFileUrl ? item.activityPicFileUrl : defaultImg
              "
              alt="暂无封面"
            />
            <div
              class="tit van-multi-ellipsis--l2"
              v-text="item.activityTitle"
            ></div>
            <div class="type" :class="`color1`">
              <!-- 活动类型为2是培训 -->
              {{
                item.activityType1 == "2"
                  ? `${item.activityTypeDesc1}-${item.activityTypeDesc2}`
                  : `${item.activityTypeDesc1}`
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="progress-wrap pt" v-show="activityProgressShow">
        <m-progress :percentage="activityProgress" />
      </div>
    </div>
    <div class="shuji-wrap" v-if="newBookList.length > 0">
      <div class="m-title-wrap">
        <div class="left">
          <div class="title">新书推荐</div>
        </div>
      </div>
      <div class="shuji-list-wrap" ref="shujiWrap">
        <div class="shuji-list">
          <div
            class="shuji-item"
            v-for="(item, index) in newBookList"
            :key="index"
            @click="handleNewBookClick(item)"
          >
            <img class="banner" :src="item.firstImgPath" alt="暂无封面" />
            <div class="tit van-ellipsis" v-text="item.title"></div>
            <div
              class="desc van-multi-ellipsis--l3"
              v-text="dItem"
              v-for="(dItem, dIndex) in item.formatDes"
              :key="dIndex"
              :style="{ paddingLeft: dItem.indexOf('【') < 0 ? '6px' : '0' }"
              v-show="dItem.length > 0"
            ></div>
          </div>
        </div>
      </div>
      <div class="progress-wrap" v-show="newBookProgressShow">
        <m-progress :percentage="newBookProgress" />
      </div>
    </div>
    <m-tab-bar active-index="0"></m-tab-bar>
    <div class="search-res-wrap" v-show="searchResShow">
      <div class="search-res-input">
        <van-search
          autofocus
          v-model="searchKeyword"
          show-action
          shape="round"
          placeholder="请输入关键词搜索"
          @input="handleSearchChange"
          @cancel="searchResShow = false"
        />
      </div>
      <div class="search-res-content">
        <div v-show="searchResAppList.length <= 0" class="search-nodata">
          暂无搜索结果
        </div>
        <div v-show="searchResAppList.length > 0">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in searchResAppList"
              :key="index"
              is-link
              @click="handleAppClick(item)"
            >
              <template #title>
                <span
                  :class="{
                    'text-red':
                      strIndex >= item.matchStartIndex &&
                      strIndex < item.matchEndIndex,
                  }"
                  v-for="(str, strIndex) in item.appName"
                  :key="strIndex"
                  v-text="str"
                ></span>
              </template>
            </van-cell>
          </van-cell-group>
        </div>
      </div>
    </div>
    <van-dialog
      v-model="noticeDialogShow"
      title="公告"
      :show-confirm-button="false"
    >
      <div class="dialog-notice more-notice" v-if="noticeShowMore">
        <pre v-html="noticeStr"></pre>
      </div>
      <div class="dialog-notice" v-else>
        <pre v-html="firstNotice"></pre>
      </div>
      <div class="btn-footer">
        <!-- <button
          v-show="noticeList.length > 1"
          class="btn submit"
          :class="noticeShowMore ? 'disabled' : ''"
          @click="noticeShowMore = true"
          :disabled="noticeShowMore"
        >
          更多
        </button> -->
        <button class="btn more" @click="noticeDialogShow = false">好的</button>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import BScroll from "better-scroll";
import MTabBar from "@/components/MTabBar";
import MProgress from "@/components/MProgress";
import { thirdAppListGet, userAuth } from "@/api/common";
import {
  hotSearchGet,
  spaceSeatGet,
  noticeInfoGet,
  // rotationInfoGet,
  newActivityGet,
  newBookGet,
} from "@/api/home";
import { STATUS_CODE_OK } from "@/config";
import {
  queryStringParameter,
  hasLoginCheck,
  setSessionStorage,
  logTrace,
  removeRickFormat,
} from "@/utils";
export default {
  name: "Home",
  data() {
    return {
      removeRickFormat,
      rotationList: [], // 轮播图列表
      noticeList: [], // 公告数组
      noticeStr: "", // 公告的内容
      firstNotice: "", //第一条公告的内容
      noticeDialogShow: false, //公告弹窗显示、隐藏
      noticeShowMore: false, //公告弹窗是否显示更多
      iconGongGao: require("@/assets/images/icon-gonggao.png"),
      campusObj: {
        show: false,
        campusId: 1,
        campusShortName: "",
        libraryOpenTime: "",
        libraryNotice: "",
        inNum: 0,
        canInNumb: 0,
        placeNum: 0,
        list: [],
      },
      hotSearchList: [], // 热搜列表
      homeUAppList: [], // 首页固定区域应用列表
      homeUnAppList: [], // 首页滚动区域应用列表
      appProgress: 0, // 第三方应用提示滚动条的位置
      appProgressShow: false, // 是否显示第三方应用的滚动条
      newActivityList: [], // 最新活动列表
      activityProgress: 0, // 活动提示滚动条的位置
      activityProgressShow: false, // 是否显示活动的滚动条
      newBookList: [], // 新书推荐列表
      newBookProgress: 0, // 新书推荐提示滚动条的位置
      newBookProgressShow: false, // 是否显示新书推荐的滚动条
      defaultImg: require("@/assets/images/peixun.jpg"),
      allAppList: [],
      searchResShow: false,
      searchResAppList: [],
      searchKeyword: "",
    };
  },
  mounted() {
    this.handleHotSearchGet();
    this.handleLocationGet();
    this.handleApplicationGet();
    this.handleNoticeInfoGet();
    // this.handleRotationInfoGet();
    this.handleNewBookGet();
    this.handleNewActivityGet();
  },
  methods: {
    // 搜索框输入变化gkwr
    handleSearchChange(keyword) {
      const name = keyword.trim();
      if (!name) {
        this.searchResAppList = [];
      } else {
        this.searchResAppList = this.allAppList.filter((item) => {
          const indexOf = item.appName.indexOf(name);
          if (indexOf >= 0) {
            item.matchStartIndex = indexOf;
            item.matchEndIndex = indexOf + name.length;
          }
          return indexOf >= 0;
        });
      }
    },
    // 校区选择切换事件
    handleCampusSelect(item) {
      this.rotationList = item.rotationInfoList;
      this.campusObj.campusId = item.campusId;
      this.campusObj.campusShortName = item.campusShortName;
      this.campusObj.inNum = item.inNum;
      this.campusObj.canInNumb = item.canInNumb;
      this.campusObj.placeNum = item.placeNum;
      this.campusObj.libraryOpenTime = item.libraryOpenTime;
      this.campusObj.libraryNotice = item.libraryNotice;
      this.$nextTick(() => {
        const swiper = this.$refs.mSwipe;
        if (swiper) {
          swiper.resize();
        }
      });
    },
    // 获取定位
    handleLocationGet() {
      const that = this;
      if (window.navigator.geolocation) {
        window.navigator.geolocation.getCurrentPosition(
          (position) => {
            that.handleSpaceSeatGet(
              position.coords.longitude,
              position.coords.latitude
            );
          },
          () => {
            that.handleSpaceSeatGet();
          },
          {
            enableHighAccuracy: true,
          }
        );
      } else {
        that.handleSpaceSeatGet();
      }
    },
    // 获取热搜信息
    async handleHotSearchGet() {
      let { data } = await hotSearchGet({
        pageSize: 5,
      });
      if (data.code === STATUS_CODE_OK) {
        if (data.data.length > 0) {
          this.hotSearchList = data.data;
        } else {
          this.hotSearchList = [
            {
              keyWords: "历史",
              base: "fdu01",
              total: 0,
            },
          ];
        }
        this.$nextTick(() => {
          if (!this.hotScroll) {
            this.hotScroll = new BScroll(this.$refs.hotWrap, {
              scrollX: true,
              scrollY: false,
              click: true,
            });
          } else {
            this.hotScroll.refresh();
          }
        });
      }
    },
    // 热搜点击事件
    handleHotSearchClick(item) {
      this.$router.push({
        path: "/bookSearch",
        query: {
          keyword: item.keyWords,
        },
      });
    },
    // 获取空间位置信息
    async handleSpaceSeatGet(longitude = "", latitude = "") {
      let { data } = await spaceSeatGet({
        longitude: longitude,
        latitude: latitude,
      });
      if (data.code === STATUS_CODE_OK) {
        this.campusObj.list = data.data.map((item) => {
          item.text = item.campusName;
          return item;
        });
        if (this.campusObj.list.length > 0) {
          let item = this.campusObj.list[0];
          this.rotationList = item.rotationInfoList;
          this.campusObj.campusId = item.campusId;
          this.campusObj.campusShortName = item.campusShortName;
          this.campusObj.inNum = item.inNum;
          this.campusObj.canInNumb = item.canInNumb;
          this.campusObj.placeNum = item.placeNum;
          this.campusObj.libraryOpenTime = item.libraryOpenTime;
          this.campusObj.libraryNotice = item.libraryNotice;
          this.$nextTick(() => {
            const swiper = this.$refs.mSwipe;
            if (swiper) {
              swiper.resize();
            }
          });
        }
      }
    },
    // 获取轮播图信息
    // async handleRotationInfoGet() {
    //   const that = this;
    //   let { data } = await rotationInfoGet();
    //   if (data.code === STATUS_CODE_OK) {
    //     that.rotationList = data.data;
    //   }
    // },
    // 公告信息
    async handleNoticeInfoGet() {
      let { data } = await noticeInfoGet({
        terminalType: "1",
      });
      if (data.code === STATUS_CODE_OK) {
        this.noticeList = data.data;
        if (this.noticeList.length > 0) {
          this.firstNotice = data.data[0];
          this.noticeStr = data.data.join("\n\r");
        }
      }
    },
    // 获取最新活动
    async handleNewActivityGet() {
      const that = this;
      let { data } = await newActivityGet();
      if (data.code === STATUS_CODE_OK) {
        that.newActivityList = data.data;
        this.handleScrollProgressInit(
          "huodongScroll",
          "huodongScroll",
          "activityProgress",
          "activityProgressShow"
        );
      }
    },
    // 获取新书推荐
    async handleNewBookGet() {
      let { data } = await newBookGet();
      if (data.code === STATUS_CODE_OK) {
        this.newBookList = data.data.map((item) => {
          item.formatDes = item.description.split("【");
          item.formatDes.forEach((fItem, index) => {
            if (fItem.indexOf("】") >= 0) {
              item.formatDes[index] = "【" + fItem;
            }
          });
          return item;
        });
        this.handleScrollProgressInit(
          "newBookScroll",
          "shujiWrap",
          "newBookProgress",
          "newBookProgressShow"
        );
      }
    },
    // 新书推荐去详情页
    handleNewBookClick(item) {
      setSessionStorage("queryParam", item);
      this.$router.push({
        path: "/newBookDetail",
      });
    },
    // 获取应用列表
    handleApplicationGet() {
      this.handleAllAppListGet();
      this.handleHomeAppListGet();
    },
    // 获取首页滚动区域应用列表
    async handleAllAppListGet() {
      const that = this;
      let { data } = await thirdAppListGet();
      if (data.code === STATUS_CODE_OK) {
        that.allAppList = data.data;
      }
    },
    // 获取首页滚动区域应用列表
    async handleHomeAppListGet() {
      const that = this;
      let { data } = await thirdAppListGet({
        appCategory: "5",
      });
      if (data.code === STATUS_CODE_OK) {
        this.homeUAppList = [];
        this.homeUnAppList = [];
        data.data.forEach((item) => {
          if (item.commonlyFlag == "Y") {
            this.homeUAppList.push(item);
          } else {
            this.homeUnAppList.push(item);
          }
        });
        that.handleScrollProgressInit(
          "appScroll",
          "appScroll",
          "appProgress",
          "appProgressShow"
        );
      }
    },
    // 点击第三方应用
    async handleAppClick(item) {
      const that = this;
      if (item.appExtUserFlag === "Y") {
        // 需要用户授权
        hasLoginCheck({
          tip: "进入此应用前，请先登录",
          path: that.$route.fullPath,
          callBack: async () => {
            // 用户已经登录，则调用接口获取authCode
            let { data } = await userAuth({
              id: item.id,
            });
            if (data.code === STATUS_CODE_OK) {
              logTrace({
                prefixUrl: that.$route.path,
                prefixUrlName: that.$route.meta.name,
                requestUrl: item.appRedirectUrl,
                rquestUrlName: item.appName,
                actionType: "page",
                actionTypeCode: "1",
                actionTypeDesc: "页面跳转",
              });
              // 跳转到第三方应用
              window.location.href = queryStringParameter(
                item.appRedirectUrl,
                "authCode",
                data.data.authCode
              );
            }
          },
        });
      } else {
        // 不需要用户授权
        if (item.routerFlag === "1") {
          // 内部url
          that.$router.push({
            path: item.appRedirectUrl,
          });
        } else {
          // 外部的url
          logTrace({
            prefixUrl: that.$route.path,
            prefixUrlName: that.$route.meta.name,
            requestUrl: item.appRedirectUrl,
            rquestUrlName: item.appName,
            actionType: "page",
            actionTypeCode: "1",
            actionTypeDesc: "页面跳转",
          });
          window.location.href = item.appRedirectUrl;
        }
      }
    },
    // 跳转到活动页面
    handleRouterActivity() {
      this.$router.push({
        path: "/activityNewest",
      });
    },
    // 跳转活动详情页
    handleActivityDetail(item) {
      this.$router.push({
        path: "/activityDetail",
        query: {
          id: item.id,
        },
      });
    },
    // 跳转到学术搜索页
    handleARouterBookSearch() {
      this.$router.push({
        path: "/bookSearch",
      });
    },

    // 跳转关键字搜索页
    handleSearchResShow() {
      this.searchKeyword = "";
      this.searchResAppList = [];
      this.searchResShow = true;
    },
    // 滚动初始化
    handleScrollProgressInit(context, dom, progress, isProgressShow) {
      const that = this;
      that.$nextTick(() => {
        if (!that[context]) {
          that[context] = new BScroll(that.$refs[dom], {
            scrollX: true,
            scrollY: false,
            click: true,
            probeType: 3,
            eventPassthrough: "vertical",
          });
          that[context].on("scroll", (position) => {
            const maxScrollX = that[context].maxScrollX;
            let scrollX = position.x;
            if (scrollX > 0) {
              scrollX = 0;
            }
            if (scrollX < maxScrollX) {
              scrollX = maxScrollX;
            }
            that[progress] = parseInt(
              ((Math.abs(scrollX) / Math.abs(maxScrollX)) * 100).toFixed(0)
            );
          });
        } else {
          that[context].refresh();
        }
        that[isProgressShow] = that[context].maxScrollX < 0;
      });
    },
    // 显示通知公告
    handleNoticeShow() {
      this.noticeShowMore = false;
      this.noticeDialogShow = true;
    },
    // 显示对应馆的开放时间
    async handleLibOpenTimeShow(libItem) {
      await this.$dialog.alert({
        title: `${libItem.campusShortName}开放时间`,
        messageAlign: "left",
        message: libItem.libraryNotice,
        confirmButtonText: "好的",
      });
    },
    // 轮播图跳转
    handleOpenUrl(url) {
      if (url) {
        window.location = url;
      }
    },
  },
  components: {
    MTabBar,
    MProgress,
  },
};
</script>

<style lang="scss">
.swiper-pagination-bullet-active {
  color: #3770d3;
}
</style>

<style scoped lang="scss">
.page {
  padding: 50px 0 90px 0;
  .top-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 0;
    height: 160px;
    background: linear-gradient(to bottom, #3770d3, #3770d3);
  }
  .search-wrap {
    padding: 10px 0;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    height: 50px;
    z-index: 667;
    display: flex;
    align-items: center;
    color: #fff;
    background-color: #3770d3;
    .campus {
      display: flex;
      align-items: center;
      padding: 0 5px 0 10px;
      .text {
        margin-right: 5px;
      }
    }
    .search {
      flex: 1;
      background-color: #fff;
      border-radius: 40px;
      height: 30px;
      font-size: 12px;
      display: flex;
      align-items: center;
      padding: 0 10px;
      margin-right: 10px;
      &.ml {
        margin-left: 10px;
      }
      .search-icon {
        height: 18px;
        margin-right: 5px;
      }
      .placeholder {
        color: #999;
      }
    }
    .consult {
      padding: 0 10px;
      .consult-icon {
        height: 20px;
      }
    }
  }
  .hot-search-wrap {
    position: relative;
    z-index: 666;
    font-size: 12px;
    padding: 0 10px 10px 10px;
    display: flex;
    align-items: center;
    color: #fff;
    .title {
      flex: none;
      width: 32px;
      margin-right: 5px;
    }
    .hot-wrap {
      flex: 1;
      overflow: hidden;
      .hot-list {
        white-space: nowrap;
        display: inline-block;
        .hot-item {
          background-color: #5083dc;
          margin: 0 5px;
          padding: 2px 10px;
          border-radius: 20px;
          display: inline-block;
        }
      }
    }
  }
  .carousel-wrap {
    padding: 0 30px;
    .m-swipe-wrap {
      height: 160px;
      .m-swipe {
        height: 100%;
        .swiper-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
  .person-num-wrap {
    padding: 20px 5px 15px 18px;
    display: flex;
    align-items: center;
    .campus-name {
      width: 58px;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #3770d3;
      font-weight: bolder;
      font-size: 12px;
      .icon-time {
        width: 22px;
        height: 22px;
        margin-bottom: 3px;
      }
      .split {
        font-size: 12px;
        line-height: 0.4;
      }
    }
    .person-num-list {
      width: 0;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      .person-num-item {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
        &::after {
          position: absolute;
          top: 15px;
          left: 0px;
          content: "";
          width: 1px;
          height: 22px;
          background-color: #ddd;
        }
        .num {
          font-size: 18px;
          color: #376fd2;
          font-weight: bolder;
          margin-bottom: 5px;
        }
        .text {
          font-size: 12px;
        }
      }
    }
  }
  .notice-wrap {
    display: flex;
    align-items: center;
    padding: 0 20px;
    .notice-icon {
      height: 16px;
    }
    .notice {
      flex: 1;
      padding: 0;
      margin-left: 5px;
    }
  }
  .u-application-wrap {
    margin: 0 10px;
  }
  .application-wrap {
    margin: 10px;
    overflow: hidden;
    .application-list {
      display: inline-block;
      white-space: nowrap;
      text-align: center;
      .application-item {
        display: inline-block;
        padding: 0 8px;
        vertical-align: top;
        .application-icon {
          width: 44px;
          height: 44px;
          object-fit: contain;
          margin: 0 auto 4px auto;
        }
        .application-text {
          font-size: 12px;
        }
      }
    }
  }
  .huodong-wrap {
    padding-top: 15px;
    .m-title-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px;
      .left {
        display: flex;
        align-items: center;
        .title {
          font-size: 16px;
          margin-right: 8px;
          color: #000;
        }
        .tip {
          border-radius: 4px;
          padding: 3px 5px;
          font-size: 12px;
          background-color: #fff4ee;
          color: #dba05c;
        }
      }
      .right {
        display: flex;
        align-items: center;
        color: #999;
        .more {
          margin-right: 2px;
        }
      }
    }
    .huodong-list-wrap {
      margin: 6px 10px;
      overflow: hidden;
      .huodong-list {
        display: inline-block;
        white-space: nowrap;
        .huodong-item {
          vertical-align: top;
          display: inline-block;
          margin-left: 15px;
          width: 135px;
          &:first-child {
            margin-left: 0;
          }
          .banner {
            display: block;
            margin: 0 auto;
            width: 135px;
            height: 170px;
            object-fit: cover;
            border-radius: 8px;
          }
          .tit {
            margin-top: 5px;
          }
          .desc {
            color: #999;
            font-size: 12px;
            margin-top: 5px;
          }
          .type {
            margin-top: 5px;
            font-size: 12px;
            &.color1 {
              color: #1989fa;
            }
            &.color2 {
              color: #07c160;
            }
            &.color3 {
              color: #ff976a;
            }
            &.color4 {
              color: #ee0a24;
            }
          }
        }
      }
    }
  }
  .shuji-wrap {
    padding-top: 15px;
    .m-title-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px;
      .left {
        display: flex;
        align-items: center;
        .title {
          font-size: 16px;
          margin-right: 8px;
          color: #000;
        }
        .tip {
          border-radius: 4px;
          padding: 3px 5px;
          font-size: 12px;
          background-color: #fff4ee;
          color: #dba05c;
        }
      }
      .right {
        display: flex;
        align-items: center;
        color: #999;
        .more {
          margin-right: 2px;
        }
      }
    }
    .shuji-list-wrap {
      margin: 6px 10px;
      overflow: hidden;
      .shuji-list {
        display: inline-block;
        white-space: nowrap;
        .shuji-item {
          display: inline-block;
          vertical-align: top;
          margin-left: 10px;
          &:first-child {
            margin-left: 0;
          }
          .banner {
            display: block;
            margin: 0 auto;
            width: 155px;
            height: 170px;
            object-fit: contain;
            border-radius: 8px;
          }
          .tit {
            margin-top: 10px;
            max-width: 210px;
            padding-left: 5px;
          }
          .desc {
            color: #999;
            font-size: 12px;
            margin-top: 5px;
            max-width: 210px;
          }
        }
      }
    }
  }
  .progress-wrap {
    display: flex;
    justify-content: center;
    &.pt {
      padding-top: 5px;
    }
  }
  .search-res-wrap {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow-y: auto;
    z-index: 999;
    background-color: #f7f8fa;
    .search-res-content {
      margin-top: 10px;
      background-color: #fff;
      .search-nodata {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 120px;
      }
      .text-red {
        color: #ee0a24;
      }
    }
  }
  .dialog-notice {
    padding: 20px 15px;
    color: #666;
    max-height: 70vh;
    overflow-y: auto;
    pre {
      white-space: pre-wrap;
      margin: 0;
    }
  }
  .btn-footer {
    display: flex;
    border-top: 1px solid #eee;
    .btn {
      flex: 1;
      border: none;
      outline: none;
      background: #fff;
      height: 44px;
      &.submit {
        border-right: 1px solid #eee;
      }
      &.more {
        color: #ee0a24;
      }
      &.disabled {
        color: #999;
      }
    }
  }
}
</style>
